import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useRef, useState } from 'react';
import { Button, Center, Flex, Input } from '@chakra-ui/react';
import { LuPlus } from 'react-icons/lu';
type CreateInputProps = {
  onCreate: (inputValue: string) => Promise<unknown>;
  onChange: (inputValue: string) => void;
  placeholder?: string;
  isCreateDisabled?: boolean;
};
const CreateInput = t0 => {
  const $ = _c(36);
  const {
    onCreate,
    onChange,
    placeholder,
    isCreateDisabled
  } = t0;
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);
  const [inputFocus, setInputFocus] = useState(false);
  let t1;
  if ($[0] !== onChange) {
    t1 = value => {
      setInputValue(value);
      onChange(value);
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  let t2;
  if ($[2] !== handleChange || $[3] !== onCreate) {
    t2 = async name => {
      await onCreate(name).then(() => {
        handleChange("");
      });
    };
    $[2] = handleChange;
    $[3] = onCreate;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleCreate = t2;
  let t3;
  if ($[5] !== inputFocus) {
    t3 = inputFocus ? {
      button: {
        borderWidth: 2,
        height: "42px"
      },
      container: {}
    } : {
      button: {
        borderWidth: 1,
        marginTop: "1px"
      },
      container: {
        paddingBottom: "1px"
      }
    };
    $[5] = inputFocus;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const dynamicStyles = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      borderRadius: "4px 0 0 4px"
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setInputFocus(false);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleChange) {
    t6 = e => handleChange(e.target.value);
    $[9] = handleChange;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setInputFocus(true);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleCreate || $[13] !== inputValue || $[14] !== isCreateDisabled) {
    t8 = e_0 => {
      if (e_0.key === "Enter" && inputValue.length > 0 && !isCreateDisabled) {
        handleCreate(inputValue);
      }
    };
    $[12] = handleCreate;
    $[13] = inputValue;
    $[14] = isCreateDisabled;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== inputValue || $[17] !== placeholder || $[18] !== t6 || $[19] !== t8) {
    t9 = <Input ref={inputRef} borderRight={0} marginTop="1px" placeholder={placeholder} style={t4} value={inputValue} onBlur={t5} onChange={t6} onFocus={t7} onKeyDown={t8} />;
    $[16] = inputValue;
    $[17] = placeholder;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = isCreateDisabled || inputValue.length === 0;
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      borderRadius: "0 4px 4px 0"
    };
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== handleCreate || $[23] !== inputValue) {
    t12 = () => handleCreate(inputValue);
    $[22] = handleCreate;
    $[23] = inputValue;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <LuPlus />;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== dynamicStyles.button || $[27] !== t10 || $[28] !== t12) {
    t14 = <Button {...dynamicStyles.button} disabled={t10} style={t11} title="Create" variant="outline" onClick={t12}>{t13}</Button>;
    $[26] = dynamicStyles.button;
    $[27] = t10;
    $[28] = t12;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14 || $[31] !== t9) {
    t15 = <Flex width="100%">{t9}{t14}</Flex>;
    $[30] = t14;
    $[31] = t9;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== dynamicStyles.container || $[34] !== t15) {
    t16 = <Center {...dynamicStyles.container} width="100%">{t15}</Center>;
    $[33] = dynamicStyles.container;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
};
export default CreateInput;